import { Space, Row, Col, Checkbox, Tooltip, Alert, Divider } from "antd";
import { CheckCircleFilled, InfoCircleFilled } from "@ant-design/icons";
import CardPartial from "../partials/Card";
import { UserFormInterface } from "../definitions";

interface Step3Props {
  services: any[];
  userForm: UserFormInterface;
  combo: boolean;
  activeTime: string | null;
  isExtensionEnabled: boolean;
  isFirstTimeSlotSelected: boolean;
  isPosting: boolean;
  onServiceChange: (serviceUuid: string, price: number, isChecked: boolean) => void;
  maxExtensionMinutes: number;
  canAdjustStart: boolean;
  canAdjustEnd: boolean;
}

const Step3: React.FC<Step3Props> = ({
  services,
  userForm,
  combo,
  activeTime,
  isExtensionEnabled,
  isFirstTimeSlotSelected,
  isPosting,
  onServiceChange,
  maxExtensionMinutes,
  canAdjustStart,
  canAdjustEnd,
}) => {
  const activeServices = services.filter((s) => s.activity_status !== false && s.is_active !== false);
  const regularServices = activeServices.filter((s) => !s.extension_minutes);
  const extensionServices = activeServices.filter((s) => !!s.extension_minutes);

  const extensionServiceUuids = extensionServices.map((s) => s.uuid);
  const hasExtensionSelected = userForm.services_selected.some((uuid) =>
    extensionServiceUuids.includes(uuid)
  );

  const renderService = (s: any) => {
    const isExtension = !!s.extension_minutes;
    const exceedsMax = isExtension && s.extension_minutes > maxExtensionMinutes;
    const isDisabled = isExtension && (!isExtensionEnabled || exceedsMax);

    const tooltipText = !isExtensionEnabled
      ? "Pratęsimas neprieinamas šiam laikui!"
      : `Šiam laikui galimas pratęsimas iki ${maxExtensionMinutes} min.`;

    return (
      <Row key={s.uuid} align={"middle"}>
        <Col>
          <Checkbox
            checked={userForm.services_selected.includes(s.uuid)}
            onChange={(e) => {
              if (!isDisabled) {
                onServiceChange(s.uuid, s.price, e.target.checked);
              }
            }}
            disabled={isDisabled}
          />
        </Col>
        <Col flex={"auto"} className="pl-5">
          {isDisabled ? (
            <Tooltip title={tooltipText}>
              <span style={{ display: "inline-block", cursor: "pointer", color: "#999" }}>
                {s.name}
              </span>
            </Tooltip>
          ) : (
            <span>{s.name}</span>
          )}
        </Col>
        <Col className="pr-2">{s.price.toFixed(0)} EUR</Col>
      </Row>
    );
  };

  return (
    <CardPartial
      isPosting={isPosting}
      title="Papildukai"
      active_time={activeTime}
    >
      <Space className="w-full" direction="vertical">
        {regularServices.map(renderService)}

        {combo === true && (
          <Row align={"middle"}>
            <small className="text-center w-full text-[#d33092]">
              <CheckCircleFilled /> Pasirinkus spragėsius ir cukraus vatą
              kartu taikoma -10 EUR nuolaida
            </small>
          </Row>
        )}

        {extensionServices.length > 0 && (
          <>
            <Divider style={{ margin: "8px 0" }}>Laiko pratęsimai</Divider>

            {isExtensionEnabled && canAdjustStart && hasExtensionSelected && (
              <Alert
                message="Gimtadienio pradžios laikas bus paankstintas"
                description="Pasirinkus pratęsimą, gimtadienis prasidės anksčiau nei nurodytas laikas."
                type="info"
                showIcon
                icon={<InfoCircleFilled />}
                style={{ marginBottom: 4 }}
              />
            )}

            {isExtensionEnabled && canAdjustEnd && hasExtensionSelected && (
              <Alert
                message="Gimtadienio laikas bus pratęstas"
                description="Pasirinkus pratęsimą, gimtadienis baigsis vėliau nei nurodytas laikas."
                type="info"
                showIcon
                icon={<InfoCircleFilled />}
                style={{ marginBottom: 4 }}
              />
            )}

            {extensionServices.map(renderService)}
          </>
        )}
      </Space>
    </CardPartial>
  );
};

export default Step3;
